import React from 'react';
import { OAuthConnection } from '../../services/RepositoryService';
import { getProviderColor, getProviderIcon } from './helpers';
import { ProviderTab } from './types';

export interface ProviderTabsProps {
  activeTab: ProviderTab;
  connections: OAuthConnection[];
  onSelect: (provider: ProviderTab) => void;
}

const PROVIDERS: ProviderTab[] = ['github', 'gitlab'];

export const ProviderTabs: React.FC<ProviderTabsProps> = ({ activeTab, connections, onSelect }) => (
  <div className="mb-6">
    <div className="border-b border-gray-200 dark:border-gray-700">
      <nav className="flex -mb-px space-x-8">
        {PROVIDERS.map((provider) => {
          const connection = connections.find((c) => c.provider === provider);
          const isActive = activeTab === provider;

          return (
            <button
              key={provider}
              onClick={() => onSelect(provider)}
              className={`group inline-flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                isActive
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
              }`}
            >
              <span className={getProviderColor(provider)}>{getProviderIcon(provider)}</span>
              <span className="capitalize">{provider}</span>
              {connection && (
                <span className="ml-2 px-2 py-0.5 rounded-full text-xs bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400">
                  Connected
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  </div>
);
